import { combineReducers } from "redux";

import * as authActionTypes from "./auth/actionTypes";
import _notif from "./notification";
import _cart from "./cart";
import _shop from "./shop";
import _auth from "./auth";
import _customer from "./customer";
import _adminOrder from "./adminOrder";
import _adminProduct from "./adminProduct";

const appReducer = combineReducers({
  notif: _notif.reducer,
  cart: _cart.reducer,
  shop: _shop.reducer,
  customer: _customer.reducer,

  auth: _auth.reducer,
  adminOrder: _adminOrder.reducer,
  adminProduct: _adminProduct.reducer,
});

const rootReducer = (state, action) => {
  //Reset the admin state on logout (the cart is kept)
  if (action.type === authActionTypes.LOGOUT) {
    return appReducer({ cart: state.cart }, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
